import { render, staticRenderFns } from "./InputFileSimple.vue?vue&type=template&id=b73f38be&"
import script from "./InputFileSimple.vue?vue&type=script&lang=ts&"
export * from "./InputFileSimple.vue?vue&type=script&lang=ts&"
import style0 from "./InputFileSimple.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports